import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { getRecycleOrderReception } from 'apis/oms';
import { RecycleOrderReception } from 'types/oms';
import formatTimeInTimezone from 'utils/formatTimeInTimezone';
import getStoreTimezone from 'utils/getStoreTimezone';
import { isJapanReceptionStore } from './options';
import i18n from '../../../../i18n';
import LOCALS from 'commons/locals';

const ReceptionEntry = ({
  orderId,
  storeId,
  submissionId,
}: {
  orderId: string;
  storeId?: number;
  submissionId?: number;
}) => {
  const [reception, setReception] = useState<RecycleOrderReception | null>();
  const visible = Boolean(submissionId) && isJapanReceptionStore(storeId);

  useEffect(() => {
    if (!visible || !submissionId) {
      setReception(undefined);
      return;
    }

    let active = true;
    getRecycleOrderReception(submissionId)
      .then((res) => {
        if (!active) return;
        setReception(res.reception || null);
      })
      .catch(() => {
        if (!active) return;
        setReception(null);
      });

    return () => {
      active = false;
    };
  }, [submissionId, visible]);

  if (!visible || reception === undefined) return null;

  const href = `/rrs/recycling-consignment-detail/${orderId}/reception?lang=ja`;

  if (!reception) {
    return (
      <Link to={href}>
        <Button type="primary">{i18n.t(LOCALS.fill_reception_form)}</Button>
      </Link>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-gray-500">
        {formatTimeInTimezone(
          reception.createTime,
          getStoreTimezone(storeId || 0),
        )}
      </span>
      <Link to={href}>
        <Button>{i18n.t(LOCALS.view_reception_form)}</Button>
      </Link>
    </div>
  );
};

export default ReceptionEntry;
